"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var enums_1 = require("../../enums");
var IconButton_1 = tslib_1.__importDefault(require("@material-ui/core/IconButton"));
var IconButton_style_1 = require("./IconButton.style");
var iconButtonHelper_1 = require("./iconButtonHelper");
var SgIconButton = function (props, ref) {
    var onClick = props.onClick, disabled = props.disabled, label = props.label, _a = props.color, color = _a === void 0 ? enums_1.Color.primary : _a, _b = props.size, size = _b === void 0 ? enums_1.Size.medium : _b, _c = props.variant, variant = _c === void 0 ? enums_1.Variant.contained : _c, name = props.name, children = props.children;
    var classes = (0, IconButton_style_1.useIconButtonStyles)();
    var sizeClass = classes[size];
    var classDisabled = variant === enums_1.Variant.contained
        ? (0, iconButtonHelper_1.getContainerColorAndDisabledClassesMap)(classes, color)
        : (0, iconButtonHelper_1.getTextColorAndDisabledClassesMap)(classes, color);
    var colorVariations = variant === enums_1.Variant.contained ? enums_1.Color.primary : enums_1.Color.secondary;
    var componentAPIClasses = {
        colorPrimary: (0, iconButtonHelper_1.getContainedColorClassesMap)(classes, color),
        colorSecondary: (0, iconButtonHelper_1.getTextColorClassesMap)(classes, color),
        disabled: classDisabled,
    };
    return (react_1.default.createElement(IconButton_1.default, tslib_1.__assign({}, props, { classes: componentAPIClasses, size: "small", className: "".concat(sizeClass), color: colorVariations, disabled: disabled, onClick: function (event) { return onClick(event); }, "aria-label": label, "data-signa": name, ref: ref }), children));
};
exports.IconButton = react_1.default.forwardRef(SgIconButton);
